import '@angular/common/locales/global/ar';
import '@angular/common/locales/global/cs';
import '@angular/common/locales/global/de';
import '@angular/common/locales/global/en';
import '@angular/common/locales/global/es';
import '@angular/common/locales/global/fr';
import '@angular/common/locales/global/it';
import '@angular/common/locales/global/ja';
import '@angular/common/locales/global/ko';
import '@angular/common/locales/global/nl';
import '@angular/common/locales/global/pl';
import '@angular/common/locales/global/pt';
import '@angular/common/locales/global/ru';
import '@angular/common/locales/global/sk';

export function browserLocale(): string {
    const language = navigator.languages?.[0]        // z. B. "de-DE"
      ?? navigator.language
      ?? 'en-US';
    return language.substring(0, 2);
  }